<template>
  <div
    class="animated fadeIn disable-text-select"
    @keyup.enter="onFilter"
    style="overflow: auto;  padding-bottom: 6rem; padding-left: 4px; padding-right: 4px;"
  >
    <div class="form-group row">
      <div class="w-100">
        <label
          style="font-size: medium; font-weight: 600;letter-spacing: 0.3px; color: #2e6e60; cursor: pointer"
          @click.prevent="
            showFilterGeral === true
              ? (showFilterGeral = false)
              : (showFilterGeral = true)
          "
        >
          <i v-if="showFilterGeral" class="fas fa-caret-down"></i>
          <i v-else class="fas fa-caret-right"></i>
          Geral</label
        >
        <!-- <div style="display: block; position: relative;top: -15px; color: #787878"><small>Campanha em rede sociais</small></div> -->
      </div>
    </div>
    <div class="pre-scrollable" v-if="showFilterGeral">
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Campanha:</label>
          <div class="input-group">
            <v-select
              v-model="form.campanha.value"
              :options="form.campanha.listOptions"
              placeholder="Selecione a campanha"
              :reduce="option => option.text"
              class="w-100"
              label="text"
            >
              <template v-slot:no-options
              >Nenhuma campanha encontrada.</template
              >
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Periodo data de Criação:</label>
          <div class="mb-1">
            <b-form-input
              type="date"
              style="height: 35px;"
              v-model="form.dataCriacaoInicial.value"
              :required="false"
              :state="form.dataCriacaoInicial.state"
            />
          </div>
          <div>
            <b-form-input
              type="date"
              style="height: 35px;"
              v-model="form.dataCriacaoFinal.value"
              :required="false"
              :state="form.dataCriacaoFinal.state"
            />
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Periodo data de Envio:</label>
          <div class="mb-1">
            <b-form-input
              type="date"
              style="height: 35px;"
              v-model="form.dataEnvioInicial.value"
              :required="false"
              :state="form.dataEnvioInicial.state"
            />
          </div>
          <div>
            <b-form-input
              type="date"
              style="height: 35px;"
              v-model="form.dataEnvioFinal.value"
              :required="false"
              :state="form.dataEnvioFinal.state"
            />
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Canal:</label>
          <div class="input-group">
            <v-select
              v-model="form.canalId.value"
              :options="form.canalId.listOptions"
              placeholder="Selecione o canal"
              :reduce="option => option.value"
              class="w-100"
              label="text"
            >
              <template v-slot:no-options>Nenhuma Canal encontrada.</template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Modelo:</label>
          <div class="input-group">
            <v-select
              v-model="form.modeloId.value"
              :options="form.modeloId.listOptions"
              :reduce="option => option.value"
              placeholder="Selecione o modelo"
              class="w-100"
              label="text"
            >
              <template v-slot:no-options>Nenhum modeloId encontrada.</template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Lista:</label>
          <div class="input-group">
            <v-select
              v-model="form.listaId.value"
              :options="form.listaId.listOptions"
              :reduce="option => option.value"
              placeholder="Selecione a lista"
              class="w-100"
              label="text"
            >
              <template v-slot:no-options>Nenhuma Lista encontrada.</template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Situação:</label>
          <div class="input-group">
            <v-select
              v-model="form.situacaoId.value"
              :options="form.situacaoId.listOptions"
              :reduce="option => option.value"
              placeholder="Selecione a situação"
              class="w-100"
              label="text"
            >
              <template v-slot:no-options
              >Nenhuma situação encontrada.</template
              >
            </v-select>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group row pt-2">
      <div class="w-100 pt-2">
        <button
          type="button"
          class="btn rounded-4 btn-third w-100"
          v-on:click="onFilter"
        >
          Filtrar
        </button>
      </div>
      <div class="w-100 pt-2">
        <button
          type="button"
          class="btn rounded-4 btn-default w-100"
          v-on:click="onClearFilters"
        >
          Limpar Filtros
        </button>
      </div>
    </div>
    <!-- <div class="form-group row" style="margin-top: 600px;">&nbsp;</div> -->
  </div>
</template>

<script>
import Roles from '@/shared/utils/roles.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools'
import { loading } from '@/shared/utils/UIHelper'
import FormSearch from './search-form.js'

import CampaignRepository from '@/shared/http/repositories/campaign/campaign.js'
import TemplateRepository from '@/shared/http/repositories/configurations/templates.js'
import SegmentationRepository from '@/shared/http/repositories/configurations/campaignlist.js'

import { JWTService } from '@/shared/services/jwt'

const DataSearch = {
  campanha: null,
  dataCriacaoInicial: null,
  dataCriacaoFinal: null,
  dataEnvioInicial: null,
  dataEnvioFinal: null,
  canalId: null,
  modeloId: null,
  listaId: null,
  situacaoId: null
}

export default {
  name: 'ReportCardSearch',
  mixins: [ActionsForm],
  data () {
    return {
      data: DataSearch,
      form: FormSearch,
      roles: Roles,
      permissions: null,
      selected: 'gerente',
      showFilterGeral: true
    }
  },
  props: {
    parentComponent: {
      type: Object
    }
  },
  created () {
    this.onClear()
    this.permissions = JWTService.GetRoles()
    this.onLoadAllCampanha()
    this.onGetAllTempalte()
    this.onGetAllSegmentation()
  },
  methods: {
    onLoad () {
      this.onClearFilters()
      this.onCloseFilterAccordion()
    },
    onClearFilters () {
      Tools.ClearDataForms(this.form, this.data)
    },
    onCloseFilterAccordion () {
      this.showFilterGeral = true
    },
    onFilter () {
      Tools.SetValueToSave(this.form, this.data)
      this.$eventHub.emit('Filter', { filters: this.data })
    },
    validateFilter () {
      this.data.campanha = this.data.campanha ? this.data.campanha : null
      this.data.dataCriacaoInicial = this.data.dataCriacaoInicial ? this.data.dataCriacaoInicial : null
      this.data.dataCriacaoFinal = this.data.dataCriacaoFinal ? this.data.dataCriacaoFinal : null
      this.data.dataEnvioInicial = this.data.dataEnvioInicial ? this.data.dataEnvioInicial : null
      this.data.dataEnvioFinal = this.data.dataEnvioFinal ? this.data.dataEnvioFinal : null
      this.data.canalId = this.data.canalId ? this.data.canalId : null
      this.data.modeloId = this.data.modeloId ? this.data.modeloId : null
      this.data.listaId = this.data.listaId ? this.data.listaId : null
      this.data.situacaoId = this.data.situacaoId ? this.data.situacaoId : null
    },
    onLoadAllCampanha () {
      loading.push()
      CampaignRepository.GetAll()
        .then(res => {
          if (res.status === 200 && res.data) {
            this.form.campanha.listOptions = res.data.content.map(x => ({'value': x.id, 'text': x.nome}))
            loading.pop()
          }
        })
        .catch(this.onException)
    },
    onGetAllTempalte () {
      loading.push()
      TemplateRepository.GetAllSortedByNome()
        .then((response) => {
          if (response.status === 200 && response.data) {
            this.form.modeloId.listOptions = this.onResultDropdown(response, null, f => f.nome)
          }
        })
        .catch(this.onException)
    },
    onGetAllSegmentation () {
      loading.push()
      SegmentationRepository.GetAllSortedByNome()
        .then((response) => {
          this.form.listaId.listOptions = this.onResultDropdown(response, null, f => f.nome)
        })
        .catch(this.onException)
    }
  }
}
</script>

<style lang="scss" scoped>
.disable-text-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.animated.fadeIn {
  padding-bottom: 2rem;
}

.animated.fadeIn::-webkit-scrollbar {
  display: none;
}

.form-group {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/reports/campanha/campanhaGeral/search/search.vue